import './App.css';
import { lazy, Suspense, useEffect, useContext } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Home from './pages/Home/Home';
import { LanguageProvider, LanguageContext } from './context/LanguageContext';
import ProtectedRoute from './components/ProtectedRoute';
import NotFound from './components/NotFound';
import LoadingScreen from './components/Loading/LoadingScreen';

const Dashboard = lazy(() => import('./components/Dashboard/Dashboard'));
const OrderPage = lazy(() => import('./pages/Order/Order'));
const OrderPage2 = lazy(() => import('./pages/Order/Order2'));
const TestDrive = lazy(() => import('./pages/TestDrive/TestDrive'));
const AboutUs = lazy(() => import('./pages/AboutUs/AboutUs'));
const Specification = lazy(() => import('./pages/Specification/Specification'));
const Specification2 = lazy(() => import('./pages/Specification/Specification2'));
const ContactUs = lazy(() => import('./pages/ContactUs/ContactUs'));
const Events = lazy(() => import('./pages/Events/Events'));
const CompanyProfile = lazy(() => import('./pages/CompanyProfile/CompanyProfile'));
const LogIn = lazy(() => import('./pages/LogIn/LogIn'));
const ServicePage = lazy(() => import('./pages/ServicePage/ServicePage'));
const OurShowRooms = lazy(() => import('./pages/OurShowRooms/OurShowRooms'));

/* ----------------------------
   APP CONTENT (uses context)
----------------------------- */
function AppContent() {
  const { currentLang } = useContext(LanguageContext);

  useEffect(() => {
    document.body.classList.remove('lang-en', 'lang-ar', 'lang-ku');
    document.body.classList.add(`lang-${currentLang}`);
  }, [currentLang]);

  return (
    <div className="App">
      <Router>
        <Suspense fallback={<LoadingScreen />}>
          <Routes>
            <Route path="/" element={<Home />} />

            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />

            <Route path="/order" element={<OrderPage />} />
            <Route path="/order2" element={<OrderPage2 />} />
            <Route path="/testDrive" element={<TestDrive />} />
            <Route path="/aboutUs" element={<AboutUs />} />
            <Route path="/specification/:modelName" element={<Specification />} />
            <Route path="/specifications1" element={<Specification />} />
            <Route path="/specifications2" element={<Specification2 />} />

            <Route path="/contactUs" element={<ContactUs />} />
            <Route path="/events" element={<Events />} />
            <Route path="/companyProfile" element={<CompanyProfile />} />
            <Route path="/kajadmin" element={<LogIn />} />
            <Route path="/notfound" element={<NotFound />} />
            <Route path="/services" element={<ServicePage />} />
            <Route path="/ourShowrooms" element={<OurShowRooms />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Suspense>
      </Router>
    </div>
  );
}

/* ----------------------------
   APP (Providers only)
----------------------------- */
function App() {
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
}

export default App;
